import React from 'react';
import { CheckCircleIcon } from '@newcore/icons';
import { FontWeights } from '@newcore/ui/enums/font-weights';
import { Text } from '@newcore/ui/typography';

/**
 * Success state - shown when device is paired
 */
export const PairingSuccessState: React.FC = React.memo(() => (
  <div className='flex flex-col items-center py-8'>
    <div className='rounded-full bg-utility-green-100 p-3'>
      <CheckCircleIcon className='h-12 w-12 text-utility-green-600' />
    </div>
    <Text as='p' weight={FontWeights.MEDIUM} className='mt-4 text-center'>
      Device paired successfully!
    </Text>
    <Text as='p' className='text-center text-tertiary'>
      Your new device is now ready to use
    </Text>
  </div>
));

PairingSuccessState.displayName = 'PairingSuccessState';
